// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { Invoice, InvoiceRegistration } from "./types";
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  invoice: InvoiceRegistration;
  notificationID: string | number;
}

export function useCreateInvoiceMutation(
  onSuccessMutation?: (data: Invoice, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {

  async function createInvoice(params: paramsType): Promise<Invoice> {
    const response = await api.post<Invoice>(
      "invoices/invoices",
      params.invoice
    );

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: createInvoice,
    onSuccess: (data, variables) => {
      onSuccessMutation?.(data, variables);
    },
    onError: onErrorMutation,
  });
}
